import updateReduxAction from '../../../../redux/actions/update'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import getByIdWorkoutSelector from '../../selectors/get-by-id'
import getCurrentOrStartedWorkoutSelect from '../../selectors/get-current-or-started'
import { logUtil } from 'packages/src'

function updateWorkoutAction (action) {
  return (dispatch, getState) => {
    const { payload } = action
    const {
      key,
      value,
      keys,
      values,
      id
      // options = {}
    } = payload

    // const shouldSave = options[REDUX_OPTION.SHOULD_SAVE] ?? true
    let workout
    if (id) {
      workout = getByIdWorkoutSelector(id)(getState())
    }
    // Update the workout
    workout = (
      workout || payload.workout || getCurrentOrStartedWorkoutSelect(getState())
    )

    if (!workout) {
      logUtil('').warn('workout was not found for action: ', action)
      return
    }
    const updates = {}
    if (keys) {
      keys.forEach((key, index) => {
        updates[key] = values[index]
      })
    } else {
      updates[key] = value
    }
    dispatch(updateReduxAction({
      type: action.type,
      payload: {
        path: getPathReduxUtil(workout),
        updates
      }
    }))

    // if (!isNewReduxUtil(workout) && shouldSave) {
    //   dispatch(
    //     saveWorkoutAction(getIdReduxUtil(workout))
    //   )
    // }
  }
}

export default updateWorkoutAction
